import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { WorkflowNewTemplate } from 'packages/workflows/ui/WorkflowAuthorTemplate';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Fragments
const RouteBase = () => {
  const navigate = useNavigate();

  return (
    <WorkflowNewTemplate
      workflowType="funding_requests"
      placeholderName="Funding Request Approval Workflow"
      heading="Add Funding Request Internal Approval"
      onCancel={() => {}}
      onSave={() => {
        navigate('/settings/funding-requests');
      }}
      canMultipleTemplatesExist={false}
    />
  );
};

// Exports
const permissions: PermissionsFn = (context) => {
  return context.flags
    .productsSettingsFundingRequestsInternalApprovalsPermissions;
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings/funding-requests" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/funding-requests" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
